import { CategoryHierarchy } from '@msdyn365-commerce/commerce-entities';

export const GetCurrentCategory = (categories: CategoryHierarchy[], categoryId?: number): CategoryHierarchy | undefined => {
    let foundCategory;
    for (const cat of categories) {
        if (categoryId && cat.RecordId === categoryId) {
            foundCategory = cat;
            break;
        } else if (cat.Children && cat.Children.length > 0) {
            const matchingChild = GetCurrentCategory(cat.Children, categoryId);
            if (matchingChild) {
                foundCategory = matchingChild;
            }
        }
    }
    return foundCategory;
};
